import React from "react";
import { Users, Trophy, Clock, BookOpen, Target } from "lucide-react";
import "./CourseOverview.css";

const benefits = [
  {
    icon: <Trophy size={26} />,
    text: "Boost your exam performance with proven strategies.",
  },
  {
    icon: <Clock size={26} />,
    text: "Save time with focused and structured learning.",
  },
  {
    icon: <BookOpen size={26} />,
    text: "Gain deep conceptual clarity in all subjects.",
  },
  {
    icon: <Target size={26} />,
    text: "Achieve your academic goals with expert mentorship.",
  },
];

const CourseOverview = () => {
  return (
    <section className="course-overview-wrapper">
      <div className="course-overview-container">
        
        {/* LEFT SIDE */}
        <div className="course-overview-left">
          <h2 className="course-overview-title">Course Overview</h2>
          <p className="course-overview-target">
            <Users size={22} /> Designed for NEET & JEE aspirants aiming for
            top ranks.
          </p>
          <p className="course-overview-desc">
            This course is crafted for ambitious students who want structured
            guidance, personalized learning, and exam-focused preparation.
            Whether you’re starting fresh or aiming to refine your skills,
            you’ll find the tools and mentorship to succeed.
          </p>
        </div>

        {/* RIGHT SIDE */}
        <div className="course-overview-right">
          <div className="course-overview-line"></div>
          {benefits.map((item, index) => (
            <div className="course-overview-benefit" key={index}>
              <div className="course-overview-icon">{item.icon}</div>
              <p className="course-overview-text">{item.text}</p>
            </div>
          ))}
        </div>

      </div>
    </section>
  );
};

export default CourseOverview;
